// ChangePassword.jsx
// import React, { useState } from "react";
// import { jwtDecode } from "jwt-decode";
// import { URL } from "../../../config";
// import "./ChangePassword.css";

// const ChangePassword = () => {
//   const [currentPassword, setCurrentPassword] = useState("");
//   const [newPassword, setNewPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [passwordError, setPasswordError] = useState("");
//   const [successMessage, setSuccessMessage] = useState("");
//   const [warningMessage, setWarningMessage] = useState("");

  
//   // Change password handler
//   const handlePasswordChange = async (e) => {
//     e.preventDefault();
//     setPasswordError("");
//     setSuccessMessage("");
//     setWarningMessage("");

//     if (newPassword !== confirmPassword) {
//       setWarningMessage("New password and confirm password do not match.");
//       setNewPassword("");
//       setConfirmPassword("");
//       return;
//     }

//     try {
//       // Get the token and extract the user id
//       const token = localStorage.getItem("token");
//       const decodedToken = jwtDecode(token);
//       const userId = decodedToken.Id.startsWith("user-")
//         ? decodedToken.Id.split("user-")[1]
//         : decodedToken.Id;

//       const response = await fetch(`${URL}/user/${userId}/change-password`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           currentPassword,
//           newPassword,
//         }),
//       });

//       if (response.ok) {
//         setSuccessMessage("Password changed successfully.");
//         setCurrentPassword("");
//         setNewPassword("");
//         setConfirmPassword("");
//       } else {
//         const errorData = await response.json();
//         setPasswordError(errorData.error);
//         setCurrentPassword("");
//         setNewPassword("");
//         setConfirmPassword("");
//       }
//     } catch (error) {
//       console.error("Error changing password:", error);
//       setPasswordError("Error changing password");
//     }
//   };

//   return (
//     <div className="changePassword-card">
//       <div className="changePassword-header">
//         <h2 className="changePassword-title">Change Password</h2>
//       </div>

//       <form className="changePassword-form" onSubmit={handlePasswordChange}>
//         {passwordError && (
//           <div className="changePassword-message error">{passwordError}</div>
//         )}
//         {successMessage && (
//           <div className="changePassword-message success">
//             {successMessage}
//           </div>
//         )}
//         {warningMessage && (
//           <div className="changePassword-message warning">
//             {warningMessage}
//           </div>
//         )}

//         <div className="changePassword-field">
//           <label className="changePassword-label">Current Password</label>
//           <input
//             type="password"
//             className="changePassword-input"
//             value={currentPassword}
//             onChange={(e) => setCurrentPassword(e.target.value)}
//           />
//         </div>

//         <div className="changePassword-field">
//           <label className="changePassword-label">New Password</label>
//           <input
//             type="password"
//             className="changePassword-input"
//             value={newPassword}
//             onChange={(e) => setNewPassword(e.target.value)}
//           />
//         </div>

//         <div className="changePassword-field">
//           <label className="changePassword-label">Confirm Password</label>
//           <input
//             type="password"
//             className="changePassword-input"
//             value={confirmPassword}
//             onChange={(e) => setConfirmPassword(e.target.value)}
//           />
//         </div>

//         <button type="submit" className="changePassword-button">
//           Change Password
//         </button>
//       </form>
//     </div>
//   );
// };

// export default ChangePassword;



// ***** Upper change password is all okay and it's checked (23-6-25) ***** //









// ***** Trasnlate EN BN added new and updated Here (23-6-25) ***** //

import React, { useState } from "react";
import { jwtDecode } from "jwt-decode";
import { URL } from "../../../config";
import "./ChangePassword.css";
import { useTranslation } from "react-i18next";

const ChangePassword = () => {
  const { t } = useTranslation();

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [warningMessage, setWarningMessage] = useState("");

  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  
  // Change password handler
  const handlePasswordChange = async (e) => {
    e.preventDefault();
    setPasswordError("");
    setSuccessMessage("");
    setWarningMessage("");

    if (newPassword !== confirmPassword) {
      // setWarningMessage("New password and confirm password do not match.");
      setWarningMessage(t('changePassword.warningMessage'));
      setNewPassword("");
      setConfirmPassword("");
      return;
    }

    try {
      // Get the token and extract the user id
      const token = localStorage.getItem("token");
      const decodedToken = jwtDecode(token);
      const userId = decodedToken.Id.startsWith("user-")
        ? decodedToken.Id.split("user-")[1]
        : decodedToken.Id;

      const response = await fetch(`${URL}/user/${userId}/change-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          currentPassword,
          newPassword,
        }),
      });

      if (response.ok) {
        // setSuccessMessage("Password changed successfully.");
        setSuccessMessage(t('changePassword.successMessage'));

        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        const errorData = await response.json();
        setPasswordError(errorData.error);
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
      }
    } catch (error) {
      console.error("Error changing password:", error);
      // setPasswordError("Error changing password");
      setPasswordError(t('changePassword.errorMessage'));
    }
  };

  return (
    <div className="changePassword-card">
      <div className="changePassword-header">
        {/* <h2 className="changePassword-title">Change Password</h2> */}
        <h2 className="changePassword-title">{t('changePassword.title')}</h2>
      </div>

      <form className="changePassword-form" onSubmit={handlePasswordChange}>
        {passwordError && (
          <div className="changePassword-message error">{passwordError}</div>
        )}
        {successMessage && (
          <div className="changePassword-message success">
            {successMessage}
          </div>
        )}
        {warningMessage && (
          <div className="changePassword-message warning">
            {warningMessage}
          </div>
        )}

        <div className="changePassword-field">
          {/* <label className="changePassword-label">Current Password</label> */}
          <label className="changePassword-label">{t('changePassword.currentPassword')}</label>
          {/* <input
            type="password"
            className="changePassword-input"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
          /> */}

           <div className="changePassword-input-wrapper">
            <input
              type={showCurrent ? "text" : "password"}
              className="changePassword-input"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
            />
            <i
              className={`fas ${showCurrent ? "fa-eye-slash" : "fa-eye"} changePassword-eye-icon`}
              onClick={() => setShowCurrent(!showCurrent)}
            ></i>
          </div>

        </div>

        <div className="changePassword-field">
          {/* <label className="changePassword-label">New Password</label> */}
          <label className="changePassword-label">{t('changePassword.newPassword')}</label>
          {/* <input
            type="password"
            className="changePassword-input"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          /> */}

          <div className="changePassword-input-wrapper">
            <input
              type={showNew ? "text" : "password"}
              className="changePassword-input"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <i
              className={`fas ${showNew ? "fa-eye-slash" : "fa-eye"} changePassword-eye-icon`}
              onClick={() => setShowNew(!showNew)}
            ></i>
          </div>

        </div>

        <div className="changePassword-field">
          {/* <label className="changePassword-label">Confirm Password</label> */}
          <label className="changePassword-label">{t('changePassword.confirmPassword')}</label>
          {/* <input
            type="password"
            className="changePassword-input"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          /> */}


          <div className="changePassword-input-wrapper">
            <input
              type={showConfirm ? "text" : "password"}
              className="changePassword-input"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <i
              className={`fas ${showConfirm ? "fa-eye-slash" : "fa-eye"} changePassword-eye-icon`}
              onClick={() => setShowConfirm(!showConfirm)}
            ></i>
          </div>

        </div>

        <button type="submit" className="changePassword-button">
          {/* Change Password */}
          {t('changePassword.button')}
        </button>
      </form>
    </div>
  );
};

export default ChangePassword;
